/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component, Fragment, Link } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import NumberFormat from 'react-number-format';
import 'react-accessible-accordion/dist/minimal-example.css';
import { bindActionCreators as bind } from 'redux';
import { connect } from 'react-redux';

import CTA from '../shared/CTA';
import { Retirement } from '../../data/ducks';
import Title from '../shared/Title';
import StartPlanResultCTA from '../shared/StartPlanResultCTA';
import MasterResults from '../shared/MasterResults';
import FinautaWhiteLogo from '../../images/svgs/finauta/logo-white.svg';
import { mp, getCampaign, withCommas } from '../../constants/utils';
import { palette, breakpoints, flexCenter, flexRow, flexColumn } from '../../constants/styles';
import { FlowHeader } from '../GoalsFlow/styles';
import { WhiteLogo, StyledBlueSpan } from '../shared/resultsStyles';
import OptionCard from '../shared/OptionCard';
import Icon from '../shared/Icon';
import Text from '../shared/Text';
import GetStarted from '../landing/GetStarted';
import { retirementVehicles, resultTypes } from '../../constants/constants';
import SimpleQA from '../shared/SimpleQA';
import { forceCheck } from 'react-lazyload';

const REPLACE_IDENTIFIER = 'XX';
const FACTOR_DE_INTEGRACION = 1.06512;

const StyledOnlyTextSection = styled.div`
  ${flexColumn}
  ${flexCenter}
`;

const StyledAchieveRetirementSection = styled.div`
  ${flexColumn}
  justify-content: center;
  align-items: center;
`;

const StyledOptionsSection = styled.div`
  margin: 0px;
`;

const StyledBadgesRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledBenefit = styled.div`
  ${flexRow}
  align-items: center;
  margin-bottom: 10px;
  ${({ withinFinancialVehicle }) => withinFinancialVehicle && css``}
`;

const StyledBenefitText = css`
  width: 80%;
  margin-left: 8px;
`;

const StyledBenefitContainer = styled.div`
  ${flexColumn}
  margin-top: 20px;
  width: 100%;
`;

const Badge = Object.freeze({
  deduction: {
    title: `Recibes $${REPLACE_IDENTIFIER} al año por devolución de impuestos`,
    icon: 'taxes',
    color: palette.secondaryColor,
  },
  custom_retirement_age: {
    title: 'Puedes elegir cuándo retirarte',
    icon: 'clock3',
    sizeDifference: 5,
    color: palette.azulClaro,
  },
  investment_choice: {
    title: 'Puedes elegir dónde invertir',
    icon: 'directionSign',
    color: palette.morado,
  },
  insurance: {
    title: 'Protección en caso de invalidez o fallecimiento',
    icon: 'shield',
    color: palette.azulFuerte,
  },
});

const StyledFinancialVehicleExplanation = styled.div`
  margin-top: 10px;
`;

const StyledUseFinancialVehicle = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
  padding: 20px;
  background-color: ${palette.terciaryColor};
  border-radius: 8px;
`;

const StyledQAContainer = styled.div`
  margin: 20px 0px 20px 0px;
`;

const StyledQAQuestion = styled.div`
  border-bottom: 1px solid black;
  margin: 0px 20px 10px 0px;
`;

const badges = [
  Badge.deduction,
  Badge.custom_retirement_age,
  Badge.investment_choice,
  Badge.insurance,
];

const AFORE_BADGES = [Badge.deduction];
const INVESTMENT_FUND_BADGES = [Badge.custom_retirement_age, Badge.investment_choice];
const PPR_BADGES = [
  Badge.deduction,
  Badge.custom_retirement_age,
  Badge.investment_choice,
  Badge.insurance,
];

const AFORE_QAS = [
  {
    question: '¿Cuánto cuesta?',
    answer: <Text type="body">No tiene costo.</Text>,
  },
  {
    question: '¿Monto mínimo de aportación?',
    answer: <Text type="body">No hay un monto mínimo.</Text>,
  },
  {
    question: '¿Disponibilidad de mi dinero?',
    answer: <Text type="body">Sólo podrás retirar tu dinero cuando cumplas 65 años.</Text>,
  },
  {
    question: 'Otros beneficios',
    answer: null,
  },
];

const INVESTMENT_FUND_QAS = [
  {
    question: '¿Cuánto cuesta?',
    answer: <Text type="body">No tiene costo.</Text>,
  },
  {
    question: '¿Monto mínimo de aportación?',
    answer: (
      <Text type="body">
        No hay un monto mínimo, pero tu primera aportación tiene que ser mayor o igual a $1,000
        pesos.
      </Text>
    ),
  },
  {
    question: '¿Disponibilidad de mi dinero?',
    answer: (
      <Text type="body">
        Tu dinero está disponible cuando tú quieras y no hay penalización por retiros.
      </Text>
    ),
  },
  {
    question: 'Otros beneficios',
    answer: null,
  },
];

const PPR_QAS = [
  {
    question: '¿Cuánto cuesta?',
    answer: <Text type="body">No tiene costo.</Text>,
  },
  {
    question: '¿Monto mínimo de aportación?',
    answer: <Text type="body">$1,500 mensuales.</Text>,
  },
  {
    question: '¿Disponibilidad de mi dinero?',
    answer: (
      <Text type="body">
        Podrás retirar tu dinero cuando cumplas 65 años o antes. Si lo retiras antes, podría aplicar
        una penalización.
      </Text>
    ),
  },
  {
    question: 'Otros beneficios',
    answer: null,
  },
];

const SUPUESTOS_QAS = [
  {
    question: 'General',
    answer: (
      <Text type="body">
        Los cálculos aquí presentados suponen que el usuario comenzó a cotizar en el IMSS o el
        ISSSTE, en caso de sí cotizar, a partir del 1 de julio de 1997. Es decir, que su pensión
        dependerá exclusivamente del saldo acumulado en su Afore y/o Plan Personal para el Retiro.
      </Text>
    ),
  },
  {
    question: 'Inflación',
    answer: (
      <Text type="body">
        La inflación promedio anual se supone de 3% con base en el objetivo de inflación de 3% +/-
        1% del Banco de México (Banxico)
      </Text>
    ),
  },
  {
    question: 'Salario, aportaciones e ingreso en el retiro',
    answer: (
      <Text type="body">
        El análisis supone que el salario, las aportaciones y el ingreso en el retiro aumentan cada
        periodo con base en la inflación.
      </Text>
    ),
  },
  {
    question: 'Rendimiento del ahorro',
    answer: (
      <Fragment>
        <Text type="body">
          El retorno nominal durante el periodo de ahorro se supone de 7% anual con base en el
          rendimiento mensual anualizado promedio de Siefores 1-4 de entre 5.6% y 7.7% entre mayo
          2013 y diciembre 2018 (CONSAR).
        </Text>
        <Text type="body">
          El retorno nominal durante el periodo de retiro se supone de 5% con base en el rendimiento
          promedio arriba de inflación de ~2% de Cetes a 28 días entre 1998 y 2018 (Banxico).
        </Text>
        <Text type="body">
          El supuesto de retorno funge fines ilustrativos y no representa un compromiso de retorno
          por parte Finauta.
        </Text>
      </Fragment>
    ),
  },
  {
    question: 'Tiempo de retiro',
    answer: (
      <Text type="body">
        El análisis supone una edad de retiro de 65 años y esperanza de vida de 90 años, la cual se
        encuentra por arriba de la expectativa de vida promedio en México en 2016 de 78 años mujeres
        y 73 años hombres (INEGI).
      </Text>
    ),
  },
  {
    question: 'Retiro ideal',
    answer: (
      <Text type="body">
        La tasa de remplazo mínima recomendada es de 70% según mejores prácticas internacionales de
        asesoría financiera.
      </Text>
    ),
  },
  {
    question: 'Beneficios fiscales',
    answer: (
      <Text type="body">
        El análisis no internaliza el impacto de deducciones fiscales por medio del ahorro en
        instrumentos financieros como Afore, Plan Personal para el Retiro (PPR) o equivalentes.
      </Text>
    ),
  },
];

const StyledFinancialVehicleDetailCTAContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const getFinancialVehicleDetail = (
  vehicleName,
  explanation,
  action,
  QAS,
  CTAText,
  savings,
  monthlyWageAfterTaxes,
  grossSalary,
) => {
  let actionWithNumber = action.replace(REPLACE_IDENTIFIER, withCommas(savings));

  return (
    <Fragment>
      <StyledFinancialVehicleExplanation>
        {explanation.map((line) => (
          <Text key={`${line}`} type="body1" style={{ marginBottom: '1em' }}>
            {line}
          </Text>
        ))}
      </StyledFinancialVehicleExplanation>
      <StyledUseFinancialVehicle>
        <Text type="body1" color="white" medium>
          {actionWithNumber}
        </Text>
      </StyledUseFinancialVehicle>
      {QAS.map((QA) => {
        let answer = QA.answer;
        if (answer === null) {
          let badges;
          switch (vehicleName) {
            case retirementVehicles.afore:
              badges = AFORE_BADGES;
              break;
            case retirementVehicles.fondo_de_inversion:
              badges = INVESTMENT_FUND_BADGES;
              break;
            case retirementVehicles.ppr:
              badges = PPR_BADGES;
              break;
            default:
              break;
          }

          answer = (
            <Fragment>
              {badges.map((badge) => {
                let badgeText = badge.title;
                if (badgeText.includes(REPLACE_IDENTIFIER)) {
                  let taxRate;
                  if (grossSalary === monthlyWageAfterTaxes) {
                    taxRate = 0.2;
                  } else {
                    taxRate = 1 - monthlyWageAfterTaxes / grossSalary;
                  }

                  let maxTaxReturn =
                    0.1 *
                    (grossSalary || monthlyWageAfterTaxes) *
                    12 *
                    FACTOR_DE_INTEGRACION *
                    taxRate;
                  let savingsTaxReturn = savings * 12 * taxRate;
                  badgeText = badgeText.replace(
                    REPLACE_IDENTIFIER,
                    withCommas(Math.floor(Math.min(maxTaxReturn, savingsTaxReturn))),
                  );
                }
                return (
                  <StyledBenefit key={`${vehicleName}-${badge.title}`} withinFinancialVehicle>
                    <Icon
                      icon={badge.icon}
                      color={badge.color}
                      size={23 - (badge.sizeDifference || 0)}
                    />
                    <Text type="body1" styles={StyledBenefitText}>
                      {badgeText}
                    </Text>
                  </StyledBenefit>
                );
              })}
            </Fragment>
          );
        }
        return (
          <SimpleQA question={QA.question} answer={answer} key={`${vehicleName}-${QA.question}`} />
        );
      })}
      {CTAText && (
        <StyledFinancialVehicleDetailCTAContainer>
          <CTA
            title={CTAText}
            buttonText={'Platiquemos'}
            event={`[${getCampaign(window.location.href)} | Retirement | Result | ${vehicleName}]`}
            onClick={() => {
              window.location = `/contacto/retiro/${vehicleName}/${encodeURIComponent(
                `app.finauta.com/retiro/res/${this.props.match.params.uuid}`,
              )}`;
            }}
          />
        </StyledFinancialVehicleDetailCTAContainer>
      )}
    </Fragment>
  );
};

const options = [
  {
    title: 'Afore',
    badges: AFORE_BADGES,
    id: retirementVehicles.afore,
    explanation: [
      'Afore es un instrumento de ahorro manejado por una institución financiera que\
    administra los fondos para el retiro de los trabajadores.',
      'Si cotizas o cotizaste en IMSS o ISSSTE, debes estar registrado por ley en una Afore.',
    ],
    action: `Para lograr tu retiro ideal, debes realizar aportaciones mensuales de $${REPLACE_IDENTIFIER} a tu Afore`,
    QAS: AFORE_QAS,
  },
  {
    title: 'Fondo de inversión',
    badges: INVESTMENT_FUND_BADGES,
    id: retirementVehicles.fondo_de_inversion,
    explanation: [
      'Es un instrumento donde pequeños inversionistas se juntan para invertir su dinero.',
      'Juntos, tienen acceso a más y mejores productos que individualmente.',
    ],
    action: `Para lograr tu retiro ideal, debes realizar aportaciones mensuales de $${REPLACE_IDENTIFIER} a un fondo de inversión`,
    QAS: INVESTMENT_FUND_QAS,
    cta: '¿Te interesa un fondo de inversión?',
  },
  {
    title: 'Plan de retiro',
    expandedTitle: 'Plan de retiro',
    badges: PPR_BADGES,
    id: retirementVehicles.ppr,
    explanation: [
      'Es un instrumento otorgado por instituciones privadas que ofrece beneficios fiscales a las personas que ven por su retiro.',
      'Los beneficios fiscales son de acuerdo al artículo 151 de LISR (Ley de Impuesto Sobre la Renta).',
    ],
    action: `Para lograr tu retiro ideal, debes realizar aportaciones mensuales de $${REPLACE_IDENTIFIER} a un plan de retiro`,
    QAS: PPR_QAS,
    cta: '¿Te interesa un plan de retiro?',
  },
];

const StyledOptionCard = css`
  margin-bottom: 10px;
`;

const StyledFinanceAreas = styled.img`
  width: 100%;
  max-width: 250px;
  margin: 2em 0;
  align-self: center;
`;

const FishingMobile = 'https://s3.us-east-2.amazonaws.com/finauta/art/fishingMobile.png';
const FishingDesktop = 'https://s3.us-east-2.amazonaws.com/finauta/art/fishing.png';

const StoryTellingIndexToDescriptionMap = {
  0: 'News',
  1: 'Recommendation',
  2: 'Fix',
  3: 'Options',
  4: 'CTA',
  5: 'More',
  6: 'AboutFinauta',
};

class Results extends Component {
  state = {
    questions: [
      {
        title: '¿Qué es Finauta?',
        answers: [
          {
            bullets: [
              'Finauta es una empresa mexicana que tiene como fin ayudarte a lograr tus metas financieras.',
              'Por medio de herramientas financieras amigables y expertos certificados, simplificamos las finanzas personales para que tú puedas lograr tus sueños.',
            ],
          },
        ],
      },
      {
        title: 'Supuestos',
        answers: [
          {
            subTitle: 'General',
            bullets: [
              'Los cálculos aquí presentados suponen que el usuario comenzó a cotizar en el IMSS o el ISSSTE, en caso de sí cotizar, a partir del 1 de julio de 1997. Es decir, que su pensión dependerá exclusivamente del saldo acumulado en su Afore y/o Plan Personal para el Retiro.',
            ],
          },
          {
            subTitle: 'Inflación',
            bullets: [
              'La inflación promedio anual se supone de 3% con base en el objetivo de inflación de 3% +/- 1% del Banco de México (Banxico)',
            ],
          },
          {
            subTitle: 'Salario, aportaciones e ingreso en el retiro',
            bullets: [
              'El análisis supone que el salario, las aportaciones y el ingreso en el retiro aumentan cada periodo con base en la inflación.',
            ],
          },
          {
            subTitle: 'Rendimiento del ahorro',
            bullets: [
              'El retorno nominal durante el periodo de ahorro se supone de 7% anual con base en el rendimiento mensual anualizado promedio de Siefores 1-4 de entre 5.6% y 7.7% entre mayo 2013 y diciembre 2018 (CONSAR).',
              'El retorno nominal durante el periodo de retiro se supone de 5% con base en el rendimiento promedio arriba de inflación de ~2% de Cetes a 28 días entre 1998 y 2018 (Banxico).',
              'El supuesto de retorno funge fines ilustrativos y no representa un compromiso de retorno por parte Finauta.',
            ],
          },
          {
            subTitle: 'Tiempo de retiro',
            bullets: [
              'El análisis supone una edad de retiro de 65 años y esperanza de vida de 90 años, la cual se encuentra por arriba de la expectativa de vida promedio en México en 2016 de 78 años mujeres y 73 años hombres (INEGI).',
            ],
          },
          {
            subTitle: 'Retiro ideal',
            bullets: [
              'La tasa de remplazo mínima recomendada es de 70% según mejores prácticas internacionales de asesoría financiera.',
            ],
          },
          {
            subTitle: 'Beneficios fiscales',
            bullets: [
              'El análisis no internaliza el impacto de deducciones fiscales por medio del ahorro en instrumentos financieros como Afore, Plan Personal para el Retiro (PPR) o equivalentes.',
            ],
          },
        ],
      },
    ],
  };

  componentWillMount() {
    const { match, retrieveRetirement } = this.props;
    if (match.params && match.params.uuid) {
      retrieveRetirement({ uuid: match.params.uuid });
      setTimeout(() => {
        this.setState({ timeoutDone: true });
      }, 2000);
    } else {
      this.setState({ timeoutDone: true, loading: false });
    }
  }

  componentDidMount = () => {
    mp(`[${getCampaign(window.location.href)}] | Retiro | Resultado`);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.error && process.env.NODE_ENV !== 'development') {
      if (nextProps.result.error.response) {
        window.location.replace(`/error/${nextProps.result.error.response.status}`);
      } else {
        window.location.replace(`/error/511`);
      }
    }
  }

  componentDidUpdate = () => {
    window.onbeforeunload = () => {
      mp(`[${getCampaign(window.location.href)}] | Retiro | Resultados | Se va`);
    };
  };

  getRetirementPercentage = (tasaDeRemplazo) => {
    let retirementPercentage = tasaDeRemplazo * 100;
    if (retirementPercentage > 100) retirementPercentage = 100;
    return retirementPercentage;
  };

  render() {
    const { questions } = this.state;

    const { match, retirement, retrievingRetirement } = this.props;

    let ret;
    if (
      (process.env.REACT_APP_NODE_ENV === 'development' && !(match.params && match.params.uuid)) ||
      (process.env.REACT_APP_NODE_ENV !== 'development' ? retrievingRetirement : true)
    ) {
      ret = {
        data: {
          age: 22,
          uuid: '5d4bbbf0',
          inputId: '5e2a624fb89ce800766f4302',
          monthlyWageAfterTaxes: 2323,
          grossSalary: 2622.202293142,
          tasaDeRemplazo: 0.40262757823308704,
          pvRetiroMensual: 935.3038642354613,
          monthlySavingForIdealRetirement: 296.3289421493393,
        },
      };
    } else {
      ret = retirement;
    }

    return (
      <MasterResults
        type={resultTypes.FULLSCREEN}
        loadingText="Cargando tu retiro..."
        loading={process.env.REACT_APP_NODE_ENV === 'development' ? false : retrievingRetirement}
        questions={questions}
        supuestos={SUPUESTOS_QAS}
        resultID="Retiro97"
        onSlideChange={(index) => {
          if (index === 2) {
            forceCheck();
          }
        }}
      >
        <StyledOnlyTextSection identifier="News" showTeaser teaserText="Pero no todo está perdido">
          <Title
            level={2}
            align="center"
            style={{
              lineHeight: 2,
              color: '#022759',
            }}
          >
            Si sigues así...
          </Title>
          <Title
            level={2}
            align="center"
            style={{
              lineHeight: 2,
              color: '#022759',
            }}
          >
            Te retirarás con{' '}
            <StyledBlueSpan>{Math.round(ret.data.tasaDeRemplazo * 100)}%</StyledBlueSpan> de tu
            salario actual, es decir{' '}
            <NumberFormat
              style={{ color: '#08aeea' }}
              value={Math.round(ret.data.pvRetiroMensual)}
              displayType="text"
              thousandSeparator
              prefix="$"
            />{' '}
            mensuales
          </Title>
        </StyledOnlyTextSection>
        <StyledOnlyTextSection identifier="Recommendation" showTeaser teaserText="¿Cómo lograrlo?">
          <Title
            level={2}
            align="center"
            style={{
              lineHeight: 2,
              color: '#022759',
            }}
          >
            En Finauta recomendamos que te retires con el <StyledBlueSpan>70%</StyledBlueSpan> de tu
            salario, es decir{' '}
            <NumberFormat
              style={{ color: '#08aeea' }}
              value={Math.round(ret.data.monthlyWageAfterTaxes * 0.7)}
              displayType="text"
              thousandSeparator
              prefix="$"
            />{' '}
            mensuales
          </Title>
        </StyledOnlyTextSection>
        {ret.data.monthlySavingForIdealRetirement && (
          <StyledOnlyTextSection identifier="Fix" showTeaser teaserText="¿Cuáles son mis opciones?">
            <Title
              level={2}
              align="center"
              style={{
                lineHeight: 2,
                color: '#022759',
              }}
            >
              Ahorrando{' '}
              <NumberFormat
                style={{ color: '#08aeea' }}
                value={Math.round(ret.data.monthlySavingForIdealRetirement)}
                displayType="text"
                thousandSeparator
                prefix="$"
              />{' '}
              al mes, lograrás tu retiro ideal
            </Title>
          </StyledOnlyTextSection>
        )}
        <StyledOptionsSection
          smallTeaser
          identifier="Options"
          showTeaser
          teaserText="¿Cuál me recomiendan?"
        >
          <Title
            level={2}
            align="center"
            style={{
              lineHeight: 2,
              color: '#022759',
              marginTop: '-20px',
              marginBottom: '0px',
            }}
          >
            Tus opciones
          </Title>
          {options.map((option, index) => (
            <OptionCard
              key={`${option.id}`}
              title={option.title}
              expandedTitle={option.expandedTitle}
              subtitle={
                <StyledBadgesRow>
                  {option.badges.map((badge) => (
                    <Icon
                      key={`${option.id}-${badge.title}`}
                      icon={badge.icon}
                      color={badge.color}
                      size={20 - (badge.sizeDifference || 0)}
                      style={{ marginRight: '5px' }}
                    />
                  ))}
                </StyledBadgesRow>
              }
              styles={index !== options.length - 1 ? StyledOptionCard : null}
            >
              {getFinancialVehicleDetail(
                option.id,
                option.explanation,
                option.action,
                option.QAS,
                option.cta,
                Math.round(ret.data.monthlySavingForIdealRetirement),
                Math.round(ret.data.monthlyWageAfterTaxes),
                Math.round(ret.data.grossSalary || ret.data.monthlyWageAfterTaxes),
              )}
            </OptionCard>
          ))}
          <StyledBenefitContainer>
            {badges.map((badge) => {
              let badgeText = badge.title;
              if (badgeText.includes(REPLACE_IDENTIFIER)) {
                let taxRate;
                if (!ret.data.grossSalary) {
                  taxRate = 0.2;
                } else {
                  taxRate = 1 - ret.data.monthlyWageAfterTaxes / ret.data.grossSalary;
                }

                let maxTaxReturn =
                  0.1 *
                  (ret.data.grossSalary || ret.data.monthlyWageAfterTaxes) *
                  12 *
                  FACTOR_DE_INTEGRACION *
                  taxRate;
                let savingsTaxReturn = ret.data.monthlySavingForIdealRetirement * 12 * taxRate;
                badgeText = badgeText.replace(
                  REPLACE_IDENTIFIER,
                  withCommas(Math.floor(Math.min(maxTaxReturn, savingsTaxReturn))),
                );
              }
              return (
                <StyledBenefit key={`main-${badge.title}`}>
                  <Icon
                    icon={badge.icon}
                    color={badge.color}
                    size={20 - (badge.sizeDifference || 0)}
                  />
                  <Text type="body1" styles={StyledBenefitText}>
                    {badgeText}
                  </Text>
                </StyledBenefit>
              );
            })}
          </StyledBenefitContainer>
        </StyledOptionsSection>
        <StyledAchieveRetirementSection identifier="CTA" showTeaser teaserText="Otras herramientas">
          <Icon icon="successHands" color={palette.secondaryColor} size={150} />
          <Title
            level={3}
            align="center"
            style={{
              lineHeight: 1.8,
              color: '#022759',
              marginBottom: '10px',
            }}
          >
            ¡Logra tu retiro ideal!
          </Title>
          <Text type="body1" align="center" light>
            Para darte una recomendación a tu medida primero nos gustaría conocerte
          </Text>
          <GetStarted
            style={{ marginTop: '20px' }}
            event={`[${getCampaign(window.location.href)}] | Retiro | Contacto`}
            showFree
            title="Platiquemos"
            to={`https://app.finauta.com/contacto/retiro/SaberMas/${encodeURIComponent(
              `app.finauta.com/retiro/res/${this.props.match.params.uuid}`,
            )}`}
          />
        </StyledAchieveRetirementSection>
        <StyledOnlyTextSection
          smallTeaser
          identifier="More"
          showTeaser
          teaserText="Más sobre Finauta"
        >
          <StartPlanResultCTA />
        </StyledOnlyTextSection>
      </MasterResults>
    );
  }
}

Results.propTypes = {
  retirement: PropTypes.object,
  error: PropTypes.bool,
  retrieveRetirement: PropTypes.func,
  retrievingRetirement: PropTypes.bool,
  match: PropTypes.object,
};

Results.defaultProps = {
  retirement: {},
  error: false,
  retrievingRetirement: true,
  retrieveRetirement: () => {},
  match: {},
};

const mapStateToProps = (state) => ({
  retirement: state.retirement.retirement,
  result: state.retirement.result,
  retrievingRetirement: state.retirement.retrievingRetirement,
  error: state.retirement.error,
});

const mapDispatchToProps = (dispatch) =>
  bind(
    {
      retrieveRetirement: Retirement.Creators.retrieveRetirementRequested,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Results);
